<div class="text-center pt-5">
	<h2 class="text-danger">🚫 Access Denied</h2>
	<p class="lead">Your account has been <strong>blocked</strong>.</p>
	<p>Please contact your administrator for assistance.</p>
</div>
